// Libs
import { ModelBase } from "@shoothill/core";
import * as MobX from "mobx";
import { IsNotEmpty, IsCurrency, IsPositive } from "class-validator";

// Models
import { CreditCardDTO } from "Globals/Models/DTO/CreditCardDTO";

import { StoresInstance } from "Globals/Stores";

export class CreditCardModel extends ModelBase<CreditCardModel, CreditCardDTO> {
    @MobX.observable public id: string | null = null;
    @MobX.observable public incomeDetailId: string | null = null;

    @IsNotEmpty({ message: "Name of acount holder is required" })
    @MobX.observable
    public acountHolderName: string | null = null;

    @IsNotEmpty({ message: "Credit card company is required" })
    @MobX.observable
    public lenderId: string | null = "0";

    @MobX.observable
    public otherLender: string = "";

    @IsNotEmpty({ message: "Monthly payment is required" })
    @MobX.observable
    public monthlyPayment: number | null = null;

    @IsNotEmpty({ message: "Balance is required" })
    @MobX.observable
    public balance: number | null = null;

    @MobX.observable public createdDate: Date | null = null;

    @MobX.observable public sameForApplicantTwo: boolean = false;

    @MobX.observable public isDeleted: boolean = false;

    @MobX.computed
    public get getIsLenderOther(): boolean {
        if (StoresInstance.Domain.LenderTypeStore.getLendersName(this.lenderId).toLocaleLowerCase() === "other") {
            return true;
        }

        return false;
    }

    @MobX.action
    public fromDto = (model: CreditCardDTO): void => {
        if (model !== null && model !== undefined) {
            this.id = model.id;
            this.incomeDetailId = model.incomeDetailId;
            this.acountHolderName = model.acountHolderName;
            this.lenderId = model.lenderId;
            this.otherLender = model.otherLender;
            this.monthlyPayment = model.monthlyPayment;
            this.balance = model.balance;
            this.createdDate = model.createdDate;
            this.sameForApplicantTwo = model.sameForApplicantTwo;
            this.isDeleted = model.isDeleted;
        }
    };

    @MobX.action
    public toDto = (): CreditCardDTO => {
        let model: CreditCardDTO = {
            id: this.id,
            incomeDetailId: this.incomeDetailId,
            acountHolderName: this.acountHolderName,
            lenderId: this.lenderId,
            otherLender: this.otherLender,
            monthlyPayment: this.monthlyPayment,
            balance: this.balance,
            createdDate: this.createdDate,
            sameForApplicantTwo: this.sameForApplicantTwo,
            isDeleted: this.isDeleted,
        };
        return model;
    };
    @MobX.action
    public resetModel = (): void => {
        this.id = null;
        this.incomeDetailId = null;
        this.acountHolderName = "";
        this.lenderId = "0";
        this.otherLender = "n/a";
        this.monthlyPayment = 0;
        this.balance = 0;
        this.createdDate = null;
        this.sameForApplicantTwo = false;
        this.isDeleted = false;
    };
}
